<script>
import { Bar } from 'vue-chartjs'
import Lib from '@/lib'
import _ from 'lodash'
import Percentage from 'percentage'
import Filesize from 'filesize'
import Util from 'util'

export default {
  extends: Bar,
  props: {
    simulations: {
      type: Array,
      default: () => ['orig'],
    },
    types: {
      type: Array,
      default: () => ['jpg', 'png', 'gif'],
    },
    summary: Object,
  },
  mounted() {
    const datasets = this.types.map(t => {
      const data = this.simulations.map(s => this.summary.images[s]).map(obj => obj.breakdown[t] || 0);
      const notOrig = this.simulations.filter(s => s != 'orig').map(s => this.summary.images[s]).map(obj => obj.breakdown[t] || 0);
      const orig = this.summary.images.orig.breakdown[t];
      const rate = (_.min(notOrig) - orig) / orig;
      const percentage = Percentage(rate, 2);
      const plusSign = rate == 0 ? '±' : rate > 0 ? '+' : '';
      const name = Lib.preset().i18n.types[t] || t;

      return {
        label: _.isNaN(rate) ? `${name} N/A` : `${name} ${plusSign}${percentage}`,
        backgroundColor: Lib.preset().colors.types[t] || '#ffffff',
        data,
      };
    });

    const labels = this.simulations.map(s => {
      const name = this.$t(`simulations.${this.summary.intent}.${s}`);
    });

    this.renderChart(
      {
        labels: this.simulations.map(s => this.$t(`simulations.${this.summary.intent}.${s}`)),
        datasets,
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        showAllTooltips: true,
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const values = data.datasets[tooltipItem.datasetIndex].data;
              const display = values.map(v => Filesize(v)).join(' → ')
              const last = values.length - 1
              const reduced = values[last] - values[0]
              const rate = reduced / values[0]

              const plusSign = rate > 0 ? '+' : ''
              return `${display} (${plusSign}${Percentage(rate, 1)})`
            },
            title: (tooltipItem, data) => {
              const label = data.datasets[tooltipItem[0].datasetIndex].label
              const [format] = label.split(/\s+/)
              return format
            },
          },
        },
        scales: {
          xAxes: [ { stacked: true } ],
          yAxes: [
            {
              ticks: {
                callback: (value, index, values) => {
                  return Filesize(value)
                },
              },
              stacked: true,
            }
          ],
        }
      }
    );
  }
}
</script>
